import { NftSelectionToggle } from "@/app/nft/nft-selection/nft-selection-toggle"
import type { NftMiniature } from "@anaconda/core/nft/types"

interface Props {
  nft: NftMiniature
}

export function NftSelection({ nft }: Props) {
  return <NftSelectionToggle nft={nft} />
}
